module.exports = __webpack_public_path__ + "71b7834a0ed4071368afd3aebe1f244f.png";